import {AdminNotificationExecutionLogModel} from "../../../models/dashboard/notification/notification";
import {
    GET_NOTIFICATION_LOGS_FAILURE,
    GET_NOTIFICATION_LOGS_SUCCESS,
    NotificationLogsInStoreAction
} from "../../../actions/dashboard/notification/updateNotificationLogsInStore";


const logsInitialState = {
    totalItemCount : 0,
    pageCount: 0,
    pageNumber: 0,
    pageSize: 0,
    items: []
} as AdminNotificationExecutionLogModel;

export const updateNotificationLogsInStoreReducer = (
    state: AdminNotificationExecutionLogModel | null = logsInitialState,
    action: NotificationLogsInStoreAction) => {
    switch (action.type) {
        case GET_NOTIFICATION_LOGS_SUCCESS:
            return {
                ...state,
                ...action.model
            };
        case GET_NOTIFICATION_LOGS_FAILURE:
            return {...state};
        default:
            return {...state};
    }
}